import http, { url } from '../../http'

const ATT = 'training-attendance'
const COV = 'training-coverage'

/** Ítem 1.2.1 — Asistencia por capacitación (acta firmable) + informe de cobertura anual. */
class TrainingAttendanceAPI {

  // ── Asistencia por capacitación ──
  async employees(companyId) {
    return await http(`${ATT}/employees/${companyId}`, 'GET')
  }

  async session(trainingId) {
    return await http(`${ATT}/session/${trainingId}`, 'GET')
  }

  async save(trainingId, payload) {
    return await http(`${ATT}/save/${trainingId}`, 'POST', payload)
  }

  async status(trainingId) {
    return await http(`${ATT}/${trainingId}/status`, 'GET')
  }

  pdfUrl(trainingId) {
    return url(`${ATT}/${trainingId}/pdf`)
  }

  async sign(trainingId, payload) {
    return await http(`${ATT}/${trainingId}/sign`, 'POST', payload)
  }

  // ── Informe de cobertura anual ──
  async coverage(companyId, year) {
    return await http(`${COV}/${companyId}?year=${year}`, 'GET')
  }

  coveragePdfUrl(companyId, year) {
    return url(`${COV}/${companyId}/pdf?year=${year}`)
  }
}

export default new TrainingAttendanceAPI()
